module.exports = __webpack_public_path__ + "images/feature/20150520_project_stats_00-af9777f2cfe63a2d2a461f0c1f93d676.png";